import { IMenuItem } from '@ra-web-tech-ui-toolkit/components';
import { ITenantDetail, PageResponse, Role } from '../lemans-app.model';

export interface TenantListPage<T> {
  tenants: PageResponse<T>;
  archivedCount: number;
}

export interface TenantRow extends Pick<
  ITenantDetail,
  'id' | 'logoUrl' | 'name' | 'description' | 'ownerName' | 'tenantStatus'
> {
  role: Role;
  userCount: number;
  hasAnyOwnerRole: boolean;
  hasDirectRole: boolean;
  parentTenantId?: string;
}

export interface TenantActionItem extends Partial<IMenuItem> {
  label?: string;
  routePath?: string;
  disabled?: boolean;
  isDivider?: boolean;
  tooltip?: string;
}

export enum TENANT_MGMT_ROUTES {
  ORGANIZATIONS = '/organizations',
  ORGANIZATIONS_SETTINGS = '/organizations/settings',
  ORGANIZATIONS_CREATE = '/organizations/create',
}

export interface TransferOwnership {
  context: {
    tenantId: string;
    tenantName: string;
    ownerName: string;
    transferType: string;
    resourceName: string;
  };
  requestBody: {
    assignee: string;
    resources: string[];
  };
}

export type ChangeParentPayload = {
  subOrgId: string;
  subOrgName: string;
  currentParentOrgId: string;
  newParentOrgId: string;
  newParentOrgName: string;
};

export interface ConvertToSubOrganization {
  context: {
    tenantId: string;
    idempotencyKey: string;
    tenantName: string;
    parentName: string;
  };
  requestBody: {
    tenant: string;
    parent: string;
  };
}

export interface ConvertToParentOrganization {
  context: {
    tenantId: string;
    idempotencyKey: string;
    tenantName: string;
  };
  requestBody: {
    child: string;
    parent: string;
    retainAdminAccess: boolean;
  };
}

export interface UserMembership {
  hasDirectRole: boolean;
  hasAnyOwnerRole: boolean;
}

export interface DeallocateEntitlementRequestBody {
  code?: string;
  allocationTimestamp?: Date;
  allocated?: number;
  quantity?: number | null;
  allocationIds?: string[] | null;
}
